export const ERRORS = {
  MISSING_BREADCRUMBS_CONTEXT:
    "useBreadcrumbsContext should be wrapped in BreadcrumbsProvider",
};
